module.exports = __webpack_public_path__ + "static/img/RC24V_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RC24V_1.png
// module id = Vif+
// module chunks = 0